import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Loading from "./Loading";

// import jwt from 'jsonwebtoken';
import { ToastContainer, toast } from "react-toastify";

const Verifylogin = (props) => {
  const navigate = useNavigate();
  const email = localStorage.getItem("email");
  const phonNo = localStorage.getItem("phone");
  const check = localStorage.getItem("check");
  const [OTP, setOTP] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const submitUserDetails = async () => {
    setIsLoading(true);
    try {
      if (check === "phone") {
        const resPhone = await axios.post(
          `${process.env.REACT_APP_SERVER_URL}/login-phone`,
          { number: phonNo, otpCode: OTP }
        );
        if (resPhone.data.success) {
          console.log("Sucess fully registered", resPhone.data.success);
          localStorage.setItem("token", resPhone.data.Token);
          console.log("token", resPhone.data.Token);

          // const decodedtoken = jwt.decode(resPhone.data.Token, { complete: true })
          // console.log("id", decodedtoken.payload.id)
          localStorage.setItem("userData", JSON.stringify(resPhone.data.user));
          console.log(
            "ksajhdfsalkdjfhlsadkf haslkfdh salkfhsalkfhas l",
            resPhone.data.user
          );

          localStorage.setItem("phone", "");
          navigate("/creator");
        }
      }
      if (check === "email") {
        const resEmail = await axios.post(
          `${process.env.REACT_APP_SERVER_URL}/login-email`,
          { email: email, otpCode: OTP }
        );
        console.log("Email Login", resEmail);
        if (resEmail.data.success) {
          
          
          console.log("Sucess fully registered", resEmail.data.success);
          localStorage.setItem("token", resEmail.data.Token);
          console.log("token", resEmail.data.user);
          localStorage.setItem("userData", JSON.stringify(resEmail.data.user));

          localStorage.setItem("email", "");
          localStorage.setItem("check", "");

          console.log("htfjhhgfhf",resEmail.data);

          if (resEmail.data.user.role == "admin") {
            navigate("/adminDashboard");
          } else if (resEmail.data.user.role == "vister") {
            navigate("/creator");
          } else if (resEmail.data.user.role == "owner") {
            navigate("/creator");
          } else {
            navigate("/");
          }
        } else {
          setIsLoading(false);

          console.log("error", resEmail.data.msg);

          // toast(resEmail.data.msg, {
          //   position: "top-right",
          //   autoClose: 5000,
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: true,
          //   draggable: true,
          //   progress: undefined,
          //   theme: "dark",
          // });

          alert(resEmail.data.msg);
        }
      }
    } catch (error) {
      setIsLoading(false);

      // alert(error)
      console.error("Error logging in:", error);
    }

    setIsLoading(false);

  };
  return (
    <>
      <div
        className="relative z-50"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-black bg-opacity-20 backdrop-blur transition-opacity"></div>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="relative bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52] rounded-lg shadow dark:bg-gray-700 py-2">
              <div className="bg-gradient-to-bl from-[#212445] via-[#212445] to-[#462E52] px-4 p-2">
                <div className="sm:flex sm:items-start">
                  <div className="p-2">
                    <h3 className="mb-2 text-xl font-medium text-white dark:text-white">
                      Verify
                    </h3>

                    <div>
                      <label
                        htmlFor="email"
                        className="block mb-2 text-sm font-medium text-white dark:text-white"
                      >
                        Enter Verification Code
                      </label>
                      <input
                        type="text"
                        name="text"
                        id="text"
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                        placeholder="Enter Verification Code"
                        required
                        onChange={(e) => setOTP(e.target.value)}
                      />
                    </div>
                    {/* <div>
                        <label htmlFor="password" className="block mb-2 text-sm font-medium text-white dark:text-white">User Name</label>
                        <input type="text" name="text" id="text" placeholder="Username" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white" required/>
                    </div> */}

                    <button
                      data-modal-hide="loginverification-modal"
                      className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                      onClick={submitUserDetails}
                    >
                      Login
                    </button>
                    <button
                      onClick={props.modalVerifyClose}
                      type="button"
                      className="my-2 w-[100%] text-center rounded-lg bg-white px-5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 "
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Loading isLoading={isLoading} />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </>
  );
};

export default Verifylogin;
